import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { EquipFieldData } from "./EquipFieldData";

export class LocationContractNotesBus extends BaseBus
{
    constructor(data: LocationContractNotesBus) {
        super(data);

    }

    CID(): any {
        return this.locationContractNoteId;
    }
    setId(id: any) {
        this.locationContractNoteId = id;
    }
    initialize(data: LocationContractNotesBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LocationContractNotesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    locationContractNoteId: string;
    dispatchId: string;
    dispatchNumber: string;
    locationId: string;
    endCustomerName: string;
    endCustomerId: string;
    endLocationName: string;
    endLocationId: string;
    note: string;
    underConstruction: string;
    updateUserId: string;
    insertDt: Date
    insertUserId: string;
    updateDt: Date;
    warrantyDt: Date;
}
